import Nullstack from 'nullstack';
export default function IconBrush({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brush",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21v-4a4 4 0 1 1 4 4h-4"
  }), "   ", Nullstack.element("path", {
    d: "M21 3a16 16 0 0 0 -12.8 10.2"
  }), "   ", Nullstack.element("path", {
    d: "M21 3a16 16 0 0 1 -10.2 12.8"
  }), "   ", Nullstack.element("path", {
    d: "M10.6 9a9 9 0 0 1 4.4 4.4"
  }), " ");
}